module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic72.06ab411.woff2";